import React from 'react'
import { useLocale } from '../i18n/LocaleContext'
import type { Locale } from '../i18n/locales'

const LanguageSwitcher: React.FC<{ className?: string }> = ({ className = '' }) => {
  const { locale, setLocale, t } = useLocale()

  const options: Locale[] = ['en', 'pl']

  return (
    <div className={`lang-switcher ${className}`.trim()} role="group" aria-label={t('lang.switch')}>
      {options.map((option) => (
        <button
          key={option}
          type="button"
          className={`lang-switcher__btn${locale === option ? ' is-active' : ''}`}
          onClick={() => setLocale(option)}
          aria-pressed={locale === option}
        >
          {t(option === 'en' ? 'lang.en' : 'lang.pl')}
        </button>
      ))}
    </div>
  )
}

export default LanguageSwitcher
